<template>
  <RevButtonBase
    class="bg-action-ai-mid text-onaction-ai-mid p-12 rounded-lg !rounded-br-sm"
    @click="$emit('click', suggestion)"
  >
    {{ suggestion }}
  </RevButtonBase>
</template>

<script lang="ts" setup>
import { RevButtonBase } from '@ds/components/ButtonBase'

defineProps<{ suggestion: string }>()

defineEmits<{ click: [suggestion: string] }>()
</script>
